import React from 'react';
import Box from '@material-ui/core/Box';
import { Links } from '../../components/links';
import { ImgWithFallback } from '../../components/ImgWithFallback';
import { MAIN_TOOLS } from '../../models';
const HeaderLogo = ({ classes, isLogin, Link }) => {
    const indexTheme = MAIN_TOOLS[0];
    const indexUrl = isLogin ? '/user/dashboard' : '/';
    return (React.createElement(Box, { className: classes.index_logo },
        React.createElement(Box, { component: 'div', sx: { display: { xs: 'none', md: 'block' } } },
            React.createElement(Links, { to: indexUrl, Link: Link },
                React.createElement(ImgWithFallback, { alt: 'logo', width: 169, height: 44, loading: 'lazy', src: indexTheme.image, fallback: indexTheme.png, customStyle: { display: 'flex' } }))),
        React.createElement(Box, { component: 'div', sx: { display: { xs: 'block', md: 'none' } } },
            React.createElement(Links, { to: indexUrl, Link: Link },
                React.createElement(ImgWithFallback, { width: 160, height: 41.6, loading: 'lazy', alt: 'logomobile', src: indexTheme.image, fallback: indexTheme.png, customStyle: { display: 'flex' } })))));
};
export default HeaderLogo;
//# sourceMappingURL=Logo.js.map